import withStyles from '@mui/styles/withStyles';
import React from "react";
import iconBlueClose from "../../assets/images/icon_blue_close.svg";

const topOffset = "0%";

const styles = (theme) => ({
  root: {
    background: "white",
    minHeight: "100vh",
  },
  kyteTecInfo: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    background: "linear-gradient(#4396e6, #a5d6e7)",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
    maxHeight: "100vh",
    overflowY: "auto",
  },
  closeIcon: {
    position: "absolute",
    top: 60,
    right: 16,
    filter:
      "invert(100%) sepia(84%) saturate(2%) hue-rotate(149deg) brightness(103%) contrast(101%)",
  },
});
function KyteTecInfoModal({ classes, setShowKyteTecInfoModal, setShowPurchaseModal }) {
  const iFrameUrl = "https://kyte-tec.com/iframe/";
  const closeModal = () => {
    console.log('click')
    setShowPurchaseModal(false)
    setShowKyteTecInfoModal(false)
  }
  return (
    <>
      <div id="scrollable-modal" className={classes.root}>
        <div className={classes.kyteTecInfo}>
          <div style={{ position: "relative", top: "15px", right: "15px" }}>
            <img
              className={classes.closeIcon}
              src={iconBlueClose}
              alt="Close kytetecmodal modal"
              onClick={(e) => closeModal()}
            />
          </div>
          <div className={classes.root}>
            <iframe
              allowtransparency="true"
              style={{ width: "100vw", height: "100vh", border: 0 }}
              src={iFrameUrl}
              title="Kyte Tec Form"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}

export default withStyles(styles)(KyteTecInfoModal);
